import styled from 'styled-components';

const Button = styled.button`
  background: #ffffff;
  color: #324971;
  font-size: 1em;
  margin: 1em;
  border-radius: 3px;
`;

export default Button;



// WEBPACK FOOTER //
// ./src/components/common/Button/index.js